import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import TrailerPage from './components/TrailerPage';

function App() {
    return (
        <Routes>
            {/* Home page at the root path */}
            <Route path="/" element={<HomePage />} />

            {/* Profile page */}
            <Route path="/trailer" element={<TrailerPage />} />
        </Routes>
    )
}

export default App;
